var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssueErrorDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 300,
    viewBox: "0 0 350 300",
    width: 350,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.293 155.112v2.591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.4766 156.516 2.1166 2.179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 162.316h2.993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.2324 168.22 2.1167-2.179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.293 168.927v-2.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.6097 167.201-1.7269-1.727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.065 162.883h-2.5904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.3382 156.839-1.7269 1.727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.309 42v1.7269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.129 47.1807h1.727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.309 52.3617v-1.7269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.627 47.1807h-1.727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.1484 114.529v2.591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.3789 122.301h2.5904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.1484 129.209v-2.591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.0571 122.301h-2.5903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.01 208.681c2.064 0 3.737 1.674 3.737 3.738s-1.673 3.738-3.737 3.738c-2.063 0-3.737-1.674-3.737-3.738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.068 257.819c.462 3.223-1.775 6.21-4.997 6.672-3.223.461-6.209-1.777-6.671-4.999-.462-3.223 1.776-6.21 4.997-6.672"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m276.113 174.768c2.219-.692 5.62-3.406 6.408-6.326.714 2.581 3.707 5.634 6.407 5.865-3.04 1.076-5.946 4.274-6.407 6.786-.314-2.561-4.334-5.952-6.408-6.325z",
    fill: "#1e2129",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m48.3438 207.529c1.1098-.346 2.8097-1.703 3.2033-3.163.357 1.29 1.8531 2.817 3.2034 2.932-1.5196.538-2.9725 2.137-3.2034 3.393-.1569-1.28-2.1668-2.976-3.2033-3.162z",
    fill: "#1e2129",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m68.9399 87.416c0 1.6014-1.2975 2.8985-2.8977 2.8985-1.6009 0-2.8977-1.2971-2.8977-2.8985 0-1.6006 1.2968-2.8984 2.8977-2.8984 1.6002 0 2.8977 1.2978 2.8977 2.8984z",
    fill: "#2d323d",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m240.058 269.397c0 2.676-2.169 4.845-4.843 4.845-2.676 0-4.844-2.169-4.844-4.845 0-2.675 2.168-4.844 4.844-4.844 2.674 0 4.843 2.169 4.843 4.844z",
    fill: "#1e2129",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m329.519 82.0733c0 2.1227-1.72 3.8428-3.841 3.8428-2.122 0-3.842-1.7201-3.842-3.8428s1.72-3.8428 3.842-3.8428c2.121 0 3.841 1.7201 3.841 3.8428z",
    fill: "#1e2129",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m123.093 261.548c0 1.338-1.084 2.422-2.422 2.422-1.337 0-2.421-1.084-2.421-2.422 0-1.339 1.084-2.423 2.421-2.423 1.338 0 2.422 1.084 2.422 2.423z",
    fillRule: "evenodd",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m121.655 68.7949c0 1.6014-1.298 2.8985-2.898 2.8985s-2.898-1.2971-2.898-2.8985c0-1.6006 1.298-2.8984 2.898-2.8984s2.898 1.2978 2.898 2.8984z",
    fillRule: "evenodd",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m195.567 288.374c-1.852.705-3.924-.226-4.628-2.077-.705-1.852.225-3.926 2.077-4.63 1.851-.704 3.923.225 4.628 2.077.705 1.853-.225 3.925-2.077 4.63z",
    fillRule: "evenodd",
    stroke: "#1e2129",
    strokeLinecap: "round",
    strokeWidth: 2.921
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m144.812 228.466h16.561l-8.675 27.602 38.644-39.037h-23.266l13.013-57.177z",
    fill: "#d13e3b",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m243.88 142.505c-2.878-2.046-6.096-3.643-9.555-4.687-2.588-.781-4.637-2.885-5.191-5.531-4.708-22.47-24.63-39.3436-48.499-39.3436-14.334 0-27.244 6.0875-36.293 15.8176-1.73 1.861-4.352 2.627-6.846 2.147-1.952-.376-3.967-.573-6.031-.573-14.929 0-27.456 10.27-30.915 24.129-.5712 2.291-2.1789 4.218-4.3355 5.178-11.5562 5.145-19.611 16.73-19.611 30.193 0 18.193 14.7046 32.947 32.8805 33.032.936.126 1.887.2 2.858.2h107.474c.371 0 .741.036 1.107.098 1.82.311 3.684.48 5.594.48 18.249 0 33.036-14.791 33.036-33.036 0-11.876-6.268-22.283-15.673-28.104z",
    fill: "#1e2129",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m152.043 123.792c-3.824-1.551-8.078-2.422-12.563-2.422-16.607 0-30.066 11.855-30.066 26.475 0 1.479.141 2.927.407 4.338 12.912-18.241 21.81-25.485 42.222-28.391z",
    fill: "#2d323d",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueErrorDark);
export default __webpack_public_path__ + "static/media/IssueErrorDark.3027f99a8a3dacd1988299e04a859c95.svg";
export { ForwardRef as ReactComponent };